<template>
  <div class="row">
    <div class="col-xl-5 col-lg-6 col-md-8 col-sm-10 mx-auto">
      <div class="d-block text-center mb-4 mb-md-5" v-if="state === 'completed'">
        <img v-if="company.avatar" :src="company.avatar" alt="Logo" width="250">

        <img src="../assets/logo.svg" v-else alt="" width="250">
      </div>

      <div class="card">
        <div v-if="state === 'loading'" class="card-body text-center">
          <breeding-rhombus-spinner
            :animation-duration="2000"
            :size="30"
            color="#2f194a"
            class="mx-auto mb-3 mt-2"
          />

          Aan het laden&hellip;
        </div>

        <div v-if="state === 'error'" class="card-body text-center p-4">
          <img
            src="../assets/illustrations/undraw_empty_xct9.svg"
            width="150"
            alt=""
          >

          <span class="h5 d-block mt-4">Geen resultaat&hellip;</span>

          <p class="text-muted mb-0">Je opdracht kon niet (meer) worden gevonden.</p>
        </div>

        <div v-if="state === 'completed'">
          <div class="card-body pt-4 pb-0 text-center">
            <h1 class="h4 mb-3">Bestelling {{ task.identifier }}</h1>
          </div>

          <div class="card-body text-center border-bottom">
            <div class="row">
              <div class="col-6">
                <span class="text-muted">Tijdstip</span>
                <span class="h5 d-block mt-2">{{ this.eta }}</span>
              </div>

              <div class="col-6">
                <span class="text-muted">Status</span>
                <span class="h5 d-block mt-2">{{ this.status }}</span>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <strong class="d-block mb-2">Adresgegevens</strong>
                {{ address.address_line }}<br>
                {{ address.postal_code }}, {{ address.city }}
              </div>

              <div class="col-md-6 mt-2 mt-md-0">
                <strong class="d-block mb-2">Levering</strong>
                <font-awesome-icon icon="calendar" class="fa-fw mr-1" />
                {{ this.deliveryDate }}<br>
                <font-awesome-icon icon="clock" class="fa-fw mr-1" />
                {{ task.time_range.start }} – {{ task.time_range.end }}
              </div>
            </div>
          </div>

          <div class="card-body border-top text-center bg-light rounded-bottom">
            <p v-if="company.track_and_trace_message">
              {{ company.track_and_trace_message }}
            </p>
            <strong class="d-block mb-1">{{ company.name }}</strong>
            {{ company.address }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BreedingRhombusSpinner } from 'epic-spinners';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'track-trace',

  data() {
    return {
      state: 'loading',
      loading: false,
      company: {},
      address: {},
      task: {},
    };
  },

  components: {
    BreedingRhombusSpinner,
  },

  computed: {
    token() {
      return this.$route.params.token;
    },

    deliveryDate() {
      return moment(this.task.date).format('LL');
    },

    eta() {
      return this.task.eta;
    },

    status() {
      if (this.task.delivered_at) {
        const time = moment(this.task.delivered_at).format('HH:mm');
        return `Afgeleverd om ${time}`;
      }

      if (this.task.is_driver_active) {
        return 'Onderweg';
      }

      return 'Ingepland';
    },
  },

  props: {
    msg: String,
  },

  watch: {
    'company.background': (background) => {
      document.body.style.backgroundImage = `url(${background})`;
    },
  },

  mounted() {
    this.fetchData();
  },

  created() {
    setInterval(this.fetchData, 15000);
  },

  methods: {
    fetchData() {
      axios
        .get(`${process.env.VUE_APP_ROUTELOGIC_APP_URL}/api/track-trace?token=${this.token}`)
        .then((res) => {
          this.state = 'completed';

          this.company = res.data.company;
          this.task = res.data.task;
          this.address = res.data.address;
        })
        .catch(() => {
          this.state = 'error';
        });
    },
  },
};
</script>
